import printy6ImageLoader from "@lib/printy6ImageLoader";
import ArrowBackIcon from "@mui/icons-material/ArrowBackIosRounded";
import ArrowForwardIcon from "@mui/icons-material/ArrowForwardIosRounded";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import Image from "next/image";
import * as React from "react";
import { Mousewheel, Thumbs } from "swiper";
import { Swiper, SwiperSlide, useSwiper } from "swiper/react";
import { useTemplate } from "../store";

export const SlideButton = styled("button")(({ theme }) => ({
  width: 40,
  height: 64,
  zIndex: 2,
  position: "absolute",
  top: "calc(50% - 32px)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "transparent",
  border: "0px",
  cursor: "pointer",
  color: theme.palette.text.primary,
  "&:disabled": {
    color: theme.palette.grey[400],
  },
}));

// const Image = styled("img")({
//   width: "100%",
//   cursor: "pointer",
// });

const SlideButtonPrev = () => {
  const swiper = useSwiper();
  const [disabled, setDisabled] = React.useState(swiper.isBeginning);

  swiper.on("activeIndexChange", function (e) {
    setDisabled(e.isBeginning);
  });

  const onClick = () => {
    swiper && swiper.slidePrev();
  };

  return (
    <SlideButton
      sx={{ left: 8 }}
      onClick={onClick}
      disabled={disabled}
      aria-label="previous image"
    >
      <ArrowBackIcon fontSize="medium" />
    </SlideButton>
  );
};

const SlideButtonNext = () => {
  const swiper = useSwiper();
  const [disabled, setDisabled] = React.useState(swiper.isEnd);

  swiper.on("activeIndexChange", function (e) {
    setDisabled(e.isEnd);
  });

  const onClick = () => {
    swiper && swiper.slideNext();
  };

  return (
    <SlideButton
      sx={{ right: 8 }}
      onClick={onClick}
      disabled={disabled}
      aria-label="next image"
    >
      <ArrowForwardIcon fontSize="medium" />
    </SlideButton>
  );
};

export default function ImagePreview({
  thumbsSwiper,
  images,
}: {
  thumbsSwiper: any;
  images: any[];
}): React.ReactElement {
  const { title } = useTemplate();

  return (
    <React.Fragment>
      <Swiper
        thumbs={{ swiper: thumbsSwiper }}
        modules={[Thumbs, Mousewheel]}
        mousewheel
        updateOnWindowResize
      >
        {images.map((image, index) => (
          <SwiperSlide key={image.id}>
            <Box
              sx={{
                fontSize: 0,
                position: "relative",
                "& img": {
                  width: "100%",
                },
              }}
            >
              <Image
                src={printy6ImageLoader({ src: image.src, quality: 1000 })}
                loading="lazy"
                width={1000}
                height={1000}
                unoptimized={true}
                alt={`${title} ${index + 1}`}
              />
            </Box>
          </SwiperSlide>
        ))}
        <SlideButtonPrev />
        <SlideButtonNext />
      </Swiper>
    </React.Fragment>
  );
}
